import React from "react";
import BaseListPage from "../../../base/BaseListPage";
import { Button, InfiniteScroll, Progress } from "nq-component";
import CardView from "../../../components/common/CardView";
import Table from "../../../components/Table";
import SearchSelect from "../../../components/searchSelect/SearchSelect";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import TrainingListForm from "../Training/TrainingTable/training-list-form/TrainingListForm";
import Search from "../../../components/Search";
import DateRangePicker from "../../../components/common/DateRangePicker";
import TrainingManagementPresenter from "./TrainingManagementPresenter";

class TrainingManagementSchedulePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TrainingManagementPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      progress: false,
      objects: [],
      filteredStatus: "",
      training: [],
      filterTrainings: "",
      object: {},
      action: "",
      isTrainingFormOpen: false,
      formMode: "View",
      count: 0,
      limit: 10,
      current: 1,
    };
  }
  async componentDidMount() {
    this.presenter.componentDidMount();
    const training = await findObjectUseCase().execute("management_training");
    this.setState({ training });
  }

  getCollectionName() {
    return "management_training";
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  filterChange(field, value) {
    this.setState({ [field]: value });
    if (field === "filterTrainings") {
      this.onChangeFilter("String", value, "training");
    } else if (field === "filteredStatus") {
      this.onChangeFilter("String", value, "stats");
    }
  }

  async handleView(objectID) {
    const objects = await findObjectUseCase().execute("management_training");
    const object = objects.find((item) => item.id === objectID.id);
    this.setState({
      object,
      action: "view",
      isTrainingFormOpen: true,
      formMode: "View",
    });
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, training, formMode, count, limit, current } =
      this.state;
    const uniqueTrainings = [...new Set(training.map((item) => item.training))];
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    const GenerateExcel = () => {
      const { objects } = this.state;
      let csvContent = "Trainings,Date,Time, Status, Methods\n"; // CSV header

      const escapeCsvValue = (value) => {
        if (typeof value === "string" && value.includes(",")) {
          return `"${value}"`;
        }
        return value;
      };

      objects.forEach((item) => {
        const training = escapeCsvValue(item.training || "");
        const date = escapeCsvValue(item.date || "");
        const time = escapeCsvValue(item.time || "");
        const stats = escapeCsvValue(item.stats || "");
        const trainingMethod = escapeCsvValue(item.trainingMethod || "");
        csvContent += `${training},${date},${time},${stats},${trainingMethod}\n`;
      });

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Training Schedule.csv`);
      document.body.appendChild(link);
      link.click();
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    };

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="pt-4 ps-5 pe-5 pb-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home &gt; Learning and Development &gt;{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    Training Schedule
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <div className=" row d-flex align-items-center">
                  <div className="col-sm-4 mt-1">
                    {/* <SearchSelect
                      value={this.state.filterTrainings || "All - Trainigs"}
                      onChange={(value) =>
                        this.filterChange("filterTrainings", value)
                      }
                      onClickClear={() =>
                        this.filterChange("filterTrainings", "")
                      }
                      disabled={this.state.filteredStatus}
                      options={[
                        {
                          label: "All - Trainigs",
                          value: "",
                        },
                        ...uniqueTrainings.map((training) => ({
                          label: training,
                          value: training,
                        })),
                      ]}
                    /> */}
                    <Search
                      schemas={this.getSchemas()}
                      onSubmit={this.searchSubmit.bind(this)}
                      fields={schema.fields}
                    />
                  </div>
                  <div className="col-sm-4 mt-1">
                    <SearchSelect
                      value={this.state.filteredStatus}
                      placeholder="Status"
                      onChange={(value) =>
                        this.filterChange("filteredStatus", value)
                      }
                      disabled={this.state.filterTrainings}
                      onClickClear={() =>
                        this.filterChange("filteredStatus", "")
                      }
                      options={[
                        ...["New", "Done", "Ongoing", "Cancelled"].map(
                          (stats) => ({
                            label: stats,
                            value: stats,
                          })
                        ),
                      ]}
                    />
                  </div>
                  <div className="col-sm-4 mt-1">
                    <DateRangePicker
                      fields={["datefrom", "dateto", ""]}
                      onFilter={(filterObj) => {
                        this.searchSubmit(filterObj);
                      }}
                    />
                  </div>
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center">
                    <h4 className="text-primary">Training Schedule</h4>
                    <div style={{ marginLeft: "auto" }}>
                      <Button
                        className="btn bg-white border border-primary text-primary"
                        onClick={() => GenerateExcel()}
                      >
                        <i className="bi bi-filetype-csv" /> CSV
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.handleView.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-search"> View</i>,
                    actionType: "object",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  [
                    "id",
                    "Created At",
                    "Updated At",
                    "targetcompetency",
                    "budgets",
                    "costs",
                    "datefrom",
                    "dateto",
                    "participants",
                  ]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isTrainingFormOpen && (
          <TrainingListForm
            closeTrainingForm={() =>
              this.setState({ isTrainingFormOpen: false })
            }
            refetchData={this.refetchData.bind(this)}
            object={this.state.object}
            action={this.state.action}
            formMode={formMode}
          />
        )}
      </>
    );
  }
}

export default TrainingManagementSchedulePage;
